import { styled } from "styled-components"
import { P } from "./Typography"
import logo from '../assets/logo.svg'

const FooterContainer = styled.div`
    border-top: 2px solid #000;
    margin-top: 2rem;
    padding-top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const GenBy = styled(P)`
    @media(max-width: 768px) {
        display: none;
    }
`

export default () => {
    return (
        <FooterContainer>
            <GenBy>Generated by</GenBy>
            <img src={logo} style={{ height: '40px', marginLeft: '1rem', marginRight: 'auto' }} />
            <a href="https://www.we-watch.ca" target="_blank">www.we-watch.ca</a>
        </FooterContainer>
    )
}